import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { IconComponent, NotificationModule } from '@ftr/foundation'
import { FtrFormsModule } from '~app/shared/ftr-forms.module'
import { MoneyModule } from '~app/shared/money/money.module'
import { LaunchDarklyModule } from '../features/launch-darkly/launch-darkly.module'

/**
 * This module imports all shared modules and re-exports them.
 * Use when your module's shared import list starts getting too long to import them all at once.
 * Please put your reusable components, pipes, directives etc into appropriate modules in this folder
 *
 * @deprecated Please use individual modules instead.
 */
@NgModule({
  imports: [
    CommonModule,
    FtrFormsModule,
    IconComponent,
    MoneyModule,
    NotificationModule,
    ReactiveFormsModule,
    RouterModule,
    LaunchDarklyModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    FtrFormsModule,
    IconComponent,
    MoneyModule,
    NotificationModule,
    ReactiveFormsModule,
  ],
})
export class SharedModule {}
